import { styled } from "styled-components";

export const SelectedImage = styled.img`
  max-width: 100%;
  height: 150px;
  margin-top: 12px;
`;
